export const testUserInfo: any = {
	isLoggedIn: true,
	user: {
		ID: "1789",
		display_name: "bobadmin",
		user_email: "bob@heem.net",
	},
  role: 'administrator'
};

export const defaultUserInfo: any = {
	isLoggedIn: false,
	user: {
		ID: "-1",
		display_name: "",
		user_email: "",
	},
  role: 'administrator'
};

const isEnglish = window.__LANG__ === 'en';

export const boardLabels: any = (label: string, boardId: number) => {
	const ko:any = {
		write: '글쓰기',
		edit: '수정하기',
		empty: '게시물이 없습니다.',
		searchPlaceholder: '검색어를 입력하세요.',
		selectAll: '전체선택',
		title: '제목',
		category: '카테고리',
		selectCategory: '카테고리 선택',
		thumbnail: '대표 이미지',
		removeThumbnail: '대표 이미지 삭제',
		attach: '첨부파일',
		youtubeLink: '유튜브 링크',
		writeSuccess: '게시물이 등록되었습니다',
		editSuccess: '게시물이 수정되었습니다',
		imageSuccess: '이미지가 등록되었습니다',
		attachSuccess: '첨부파일이 등록되었습니다',
		list: '목록',
		delete: '삭제',
	};

	const en:any = {
		write: 'Write',
		edit: 'Edit',
		empty: 'Not Found',
		searchPlaceholder: 'Search box',
		selectAll: 'Select All',
		title: 'Project Title',
		category: 'Category',
		selectCategory: 'Select Category',
		thumbnail: 'Thumbnail',
		removeThumbnail: 'Remove Thumbnail',
		attach: 'Attach a Final Report',
		youtubeLink: 'Youtube Link',
		writeSuccess: 'The post has been registered',
		editSuccess: 'The post has been modified',
		imageSuccess: 'The image has been registered',
		attachSuccess: 'The attachment has been registered',
		list: 'List',
		delete: 'Delete',
	}

	return (boardId === 30 || isEnglish) ? en[label] : ko[label];

}
